import './src/styles/reset.css'
import './src/styles/global.css'
import './src/styles/custom.css'
import { Amplify } from 'aws-amplify'
import awsExports from './src/aws-exports'

Amplify.configure(awsExports)
